import React from 'react';
import DataDrivenGuidePage from '../../components/guides/DataDrivenGuidePage';

const J1939FrameDecoderGuidePage = () => <DataDrivenGuidePage slug="guide-j1939-frame-decoder" />;

export default J1939FrameDecoderGuidePage;
